import styles from '../AveragesOverviewTable/style.postcss';

import React, { Component } from 'react';
import { List } from 'immutable';
import { ProductionStatus } from 'omni-common-ui';
import ExpansionButton from 'components/ExpansionButton';
import { TableView, TableViewTr, MemberCardTd,
 ProgressBarTd, NormalTd, HeaderTd } from 'components/TableView';
import { parseProductionStatus } from 'domain/ProductionStatus';
import PropTypes from 'prop-types';
import is from 'is_js';

const SORT_KEYS = {
  status: 'status',
  class: 'class',
  practice: 'practice',
  unitQuiz: 'unitQuiz',
  reader: 'reader',
  vocabulary: 'vocabulary',
};

class RewardsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpand: false,
      sortKey: SORT_KEYS.class,
      sortType: 'Ascending',
      filterParams: {},
      isShowPercent: false,
    };
    this._handleOnFilterChange = this._handleOnFilterChange.bind(this);
    this._onSwitchButtonClicked = this._onSwitchButtonClicked.bind(this);
  }

  _handleOnFilterChange(filterParams) {
    this.setState({ filterParams });
  }

  _onSwitchButtonClicked() {
    this.setState({ isShowPercent: ! this.state.isShowPercent });
  }

  _renderTableRow(row) {
    const { isInProduction } = row;
    const status = Object.assign({ isInProduction }, parseProductionStatus(row.status));
    const isShowPercent = this.state.isShowPercent;

    if (is.existy(row.rewards)) {
      return <TableViewTr key={`${row.studentGeneralInfo.id}-performance`}>
        <MemberCardTd name={`${row.studentGeneralInfo.firstName} ${row.studentGeneralInfo.lastName}`}
            surname={row.studentGeneralInfo.localName}
            avatarUrl={row.studentGeneralInfo.avatarUrl}
            gender={row.studentGeneralInfo.gender} />
        <NormalTd>
          <ProductionStatus status={row.status} highlighted={status.isInProduction} />
        </NormalTd>
        <ProgressBarTd className={styles.PerformanceCard_mobileLastColomn}
            percent={Math.round(row.rewards.classesCompletedPercent)}
            progressValue={isShowPercent ? null : `${row.rewards.completedClasses}/${row.rewards.totalClasses}`} />

        <ProgressBarTd className={styles.PerformanceCard_mobileLastColomn}
            percent={Math.round(row.rewards.homeworksCompletedPercent)}
            progressValue={isShowPercent ? null : `${row.rewards.completedHomeworks}/${row.rewards.totalHomeworks}`} />

        <ProgressBarTd className={styles.PerformanceCard_mobileLastColomn}
            percent={Math.round(row.rewards.unitQuizCompletedPercent)}
            progressValue={isShowPercent ? null : `${row.rewards.completedUnitQuiz}/${row.rewards.totalUnitQuiz}`} />

        <ProgressBarTd className={styles.PerformanceCard_mobileLastColomn}
            percent={Math.round(row.rewards.readersCompletedPercent)}
            progressValue={isShowPercent ? null : `${row.rewards.completedReaders}/${row.rewards.totalReaders}`} />

        <ProgressBarTd className={styles.PerformanceCard_mobileLastColomn}
            percent={Math.round(row.rewards.wordsCompletedPercent)}
            progressValue={isShowPercent ? null : `${row.rewards.completedWords}/${row.rewards.totalWords}`} />
      </TableViewTr>;
    }

    return <TableViewTr key={`${row.studentGeneralInfo.id}-performance`}>
      <MemberCardTd name={`${row.studentGeneralInfo.firstName} ${row.studentGeneralInfo.lastName}`}
          surname={row.studentGeneralInfo.localName}
          avatarUrl={row.studentGeneralInfo.avatarUrl}
          gender={row.studentGeneralInfo.gender} />
      <NormalTd>
        <ProductionStatus status={row.status} highlighted={status.isInProduction} />
      </NormalTd>
      <NormalTd className={styles.PerformanceCard_mobileLastColomn}>-</NormalTd>
      <NormalTd className={styles.PerformanceCard_mobileLastColomn}>-</NormalTd>
      <NormalTd className={styles.PerformanceCard_mobileLastColomn}>-</NormalTd>
      <NormalTd className={styles.PerformanceCard_mobileLastColomn}>-</NormalTd>
      <NormalTd className={styles.PerformanceCard_mobileLastColomn}>-</NormalTd>
    </TableViewTr>;
  }

  _renderExpansionButton() {
    const { groupPerformance } = this.props;
    if (groupPerformance.studentsPerformance.size <= 4) {
      return null;
    }
    return <ExpansionButton isExpand={this.state.isExpand}
        className={styles.PerformanceCard_expansion}
        onExpansionButtonClick={() => this.setState({ isExpand: ! this.state.isExpand })} />;
  }

  _renderTableHeaderRow() {  // overridden/used in PerformanceCard!
    const { sortKey, sortType } = this.state;
    const headers = new List([{ key: 'name', text: 'Name', sortable: true },
      { key: SORT_KEYS.status, text: 'Status', sortable: false },
      { key: SORT_KEYS.class, text: 'Class', sortable: true },
      { key: SORT_KEYS.practice, text: 'Practice', sortable: true },
      { key: SORT_KEYS.unitQuiz, text: 'Unit Quiz', sortable: true },
      { key: SORT_KEYS.reader, text: 'Reader', sortable: true },
      { key: SORT_KEYS.vocabulary, text: 'Vocabulary', sortable: true }]);

    return <TableViewTr key="PerformanceCard-hrow2">
      {
        headers.map((header) => <HeaderTd sortable={header.sortable}
            sortType={sortKey === header.key ? sortType : ''}
            onSort={() => this._sort(header.key)}
            key={header.key}>
          {header.text}
        </HeaderTd>)
      }
    </TableViewTr>;
  }

  _sort(sortKey) {
    let sortType = 'Ascending';
    if (sortKey === this.state.sortKey) {
      sortType = this.state.sortType === 'Ascending' ? 'Descending' : 'Ascending';
    }
    this.setState({ sortKey, sortType });
  }

  render() {
    const { groupPerformance } = this.props;
    const { startUnitNumber, endUnitNumber } = groupPerformance;
    const tableTitle = startUnitNumber === endUnitNumber ?
      `Performance (Unit ${startUnitNumber})` :
      `Performance (Units ${startUnitNumber}-${endUnitNumber})`;
    const viewCount = groupPerformance.studentsPerformance.size >= 4 ? 4 :
      groupPerformance.studentsPerformance.size;
    const sortedstudentsPerformance = groupPerformance
      .studentsPerformance.sort((currentObject, nextObject) => {
        let current = currentObject.get(this.state.sortKey);
        let next = nextObject.get(this.state.sortKey);
        if (this.state.sortKey === 'name') {
          current = `${currentObject.studentGeneralInfo.firstName} ${currentObject.studentGeneralInfo.lastName}`.toLowerCase();
          next = `${nextObject.studentGeneralInfo.firstName} ${nextObject.studentGeneralInfo.lastName}`.toLowerCase();
        } else {
          switch (this.state.sortKey) {
            case SORT_KEYS.class:
              current = currentObject.rewards && currentObject.rewards.classesCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.classesCompletedPercent;
              break;
            case SORT_KEYS.practice:
              current = currentObject.rewards && currentObject.rewards.homeworksCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.homeworksCompletedPercent;
              break;
            case SORT_KEYS.unitQuiz:
              current = currentObject.rewards && currentObject.rewards.unitQuizCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.unitQuizCompletedPercent;
              break;
            case SORT_KEYS.reader:
              current = currentObject.rewards && currentObject.rewards.readersCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.readersCompletedPercent;
              break;
            case SORT_KEYS.vocabulary:
              current = currentObject.rewards && currentObject.rewards.wordsCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.wordsCompletedPercent;
              break;
            default:
              break;
          }
        }

        // Make sure none score student sorted bottom.
        if (this.state.sortType === 'Ascending') {
          current = current === null ? 101 : current;
          next = next === null ? 101 : next;
        } else if (this.state.sortType === 'Descending') {
          current = current === null ? - 101 : current;
          next = next === null ? - 101 : next;
        }
        // Make sure Swapped student sorted bottom.
        if (currentObject.status === 'Swapped') {
          return 1;
        } else if (nextObject.status === 'Swapped') {
          return - 1;
        }
        if (current > next) {
          return this.state.sortType === 'Ascending' ? 1 : - 1;
        } else if (current < next) {
          return this.state.sortType === 'Ascending' ? - 1 : 1;
        }
        return 0;
      });
    const source = this.state.isExpand ?
      sortedstudentsPerformance :
      sortedstudentsPerformance.slice(0, viewCount);
    return <TableView source={source}
        tableTitle={tableTitle}
        renderTableRow={(row) => this._renderTableRow(row)}
        noResultsString="No Results."
        query={this.state.filterParams}
        onFilterChange={this._handleOnFilterChange}
        customerFooter={this._renderExpansionButton()}
        customerHeader={this._renderTableHeaderRow()} />;
  }
}

RewardsTable.propTypes = {
  groupPerformance: PropTypes.object.isRequired,
};

export default RewardsTable;



// WEBPACK FOOTER //
// ./containers/Group/Dashboard/PerformanceCard/RewardsTable/index.jsx